import React from "react";
import Typography from "@mui/material/Typography";
import { Grid } from "@mui/material";
import { resultadoFinalText } from "../../../AlunoTurma/ResultadoFinal";

export default function RelatorioCabecalhoWeb({ alunoTurma }) {
  return (
    <div
      style={{
        border: "1px solid black",
        padding: "20px",
        margin: "20px",
      }}
    >
      <Grid container spacing={2}>
        <Grid size={12}>
          <Grid container direction={"row"} justifyContent={"space-evenly"}>
            <Grid>
              <Typography>Código: {alunoTurma.aluno.codAlunoEscola}</Typography>
            </Grid>
            <Grid>
              <Typography>Aluno: {alunoTurma.aluno.nome}</Typography>
            </Grid>
            <Grid>
              <Typography>Turma: {alunoTurma.turma.descricao}</Typography>
            </Grid>
            <Grid>
              <Typography>Ano Letivo: {alunoTurma.turma.anoLetivo}</Typography>
            </Grid>
          </Grid>
        </Grid>
        {alunoTurma.resultadoFinalEnum && (
          <Grid size={12}>
            <Grid container direction={"row"} justifyContent={"space-evenly"}>
              <Grid>
                <Typography>
                  Resultado Final:{" "}
                  {resultadoFinalText(alunoTurma.resultadoFinalEnum)}
                </Typography>
              </Grid>
            </Grid>
          </Grid>
        )}
      </Grid>
    </div>
  );
}
